import { currencyFormat } from '@fiverr-private/localization';

export const showLocalisedAmountOver = ({
    amountOver = 0,
    currency = {
        rate: 1,
        name: 'USD',
    },
}: {
    amountOver?: number;
    currency?: {
        rate: number;
        name: string;
    };
}) => {
    const amount = (amountOver * currency.rate) / 100;

    return currencyFormat({
        value: amount,
        currencyCode: currency.name,
        options: {
            fallbackValue: `$${amount}`,
            maximumFractionDigits: 0,
        },
    }).toString();
};
